module.exports = __webpack_public_path__ + "static/media/S (163).d6461706.jpg";